import MessagesWidget from "views/logic/widgets/MessagesWidget";
import ExportMessageWidgetActionComponent from "views/components/widgets/ExportWidgetAction/ExportMessageWidgetActionComponent";
const ExportMessageWidgetAction = {
  type: "export-messages-widget-action",
  position: "menu",
  isHidden: (w) => w.type !== MessagesWidget.type,
  component: ExportMessageWidgetActionComponent
};
export default ExportMessageWidgetAction;
